import './App.css';
import ClientRoutes from './ClientRoutes';
import {QueryClient, QueryClientProvider,} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
import {ReactKeycloakProvider} from "@react-keycloak/web";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import {store} from './store/store'
import {Provider} from 'react-redux'
import keycloak from "./keycloak";
import {useState} from "react";
import {setToken} from "./store/auth";

import {PersistGate} from 'redux-persist/integration/react'
import {persistStore} from 'redux-persist'

let persistor = persistStore(store);

// Create a client
const queryClient = new QueryClient()


function App() {
    const [isLoading, _setIsLoading] = useState(true);
    const eventLogger = (event, error) => {
        _setIsLoading(false);
    }

    const tokenLogger = (tokens) => {
        store.dispatch(setToken(tokens.token))
    }

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            onEvent={eventLogger}
            onTokens={tokenLogger}
            initOptions={{
                onLoad: "check-sso",
                checkLoginIframe: false,
            }}
        >
            {
                !isLoading &&
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <QueryClientProvider client={queryClient}>
                            <div className="App">
                                <ClientRoutes/>
                            </div>
                            <ReactQueryDevtools initialIsOpen={false}/>
                        </QueryClientProvider>
                    </PersistGate>
                </Provider>

            }
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </ReactKeycloakProvider>
    );
}

export default App;
